document.addEventListener('DOMContentLoaded', function () {
  const setTabListeners = (tabContainer) => {
    // console.log('setTabListeners');

    const tabListItems = tabContainer.querySelectorAll('.tabs-divisions__list-item');

    for (let i = 0; i < tabListItems.length; i += 1) {
      const { tabTarget } = tabListItems[i].dataset;

      tabListItems[i].addEventListener('click', function () {
        showTab(tabTarget, tabContainer);
      }, false);
    }
  };

  const showTab = (tabName, tabContainer) => {
    // console.log('showTab');

    const tabContentAreas = tabContainer.querySelectorAll('.tabs-divisions__content');

    for (let i = 0; i < tabContentAreas.length; i += 1) {
      const tab = tabContentAreas[i];
      const { tabLocation } = tabContentAreas[i].dataset;

      if (tabLocation === tabName) {
        tab.classList.add('is-active');
      } else {
        tab.classList.remove('is-active');
      }
    }
  };

  const setupTabs = () => {
    const tabElements = document.querySelectorAll('.tabs-divisions');

    if (tabElements.length > 0) {
      for (let i = 0; i < tabElements.length; i += 1) {
        const item = tabElements[i];

        setTabListeners(item);
      }
    }
  };

  setupTabs();
});
